import { useState } from 'react';

import type { ICommunitiesViewCommunity } from '../../../../redux/api/communities/communities-api.types';
import {
  useSubscribeToCommunity,
  useUnsubscribeFromCommunity,
} from '../../../../redux/api/communitiesApi';
import { useOptionalCommunitiesListRefresh } from '../CommunitiesListRefreshContext';

export function useCommunityBigItem(community: ICommunitiesViewCommunity) {
  const refreshCommunitiesList = useOptionalCommunitiesListRefresh();

  const [subscribeToCommunity, { isLoading: isSubscribeMutationLoading }] =
    useSubscribeToCommunity();
  const [
    unsubscribeFromCommunity,
    { isLoading: isUnsubscribeMutationLoading },
  ] = useUnsubscribeFromCommunity();

  const [pendingSubscribe, setPendingSubscribe] = useState<string | null>(null);
  const [pendingUnsubscribe, setPendingUnsubscribe] = useState<string | null>(
    null,
  );

  async function onSubscribe(communityId: string) {
    setPendingSubscribe(communityId);
    try {
      await subscribeToCommunity({ id: communityId }).unwrap();
      void refreshCommunitiesList?.();
    } catch (e) {
      console.log(e);
    } finally {
      setPendingSubscribe(null);
    }
  }

  async function onUnsubscribe(communityId: string) {
    setPendingUnsubscribe(communityId);
    try {
      await unsubscribeFromCommunity({ id: communityId }).unwrap();
      void refreshCommunitiesList?.();
    } catch (e) {
      console.log(e);
    } finally {
      setPendingUnsubscribe(null);
    }
  }

  const isThisCommunity = (id: string) => id === community.id;

  return {
    onSubscribe,
    onUnsubscribe,
    isSubscribeLoading:
      isThisCommunity(pendingSubscribe ?? '') && isSubscribeMutationLoading,
    isUnsubscribeLoading:
      isThisCommunity(pendingUnsubscribe ?? '') && isUnsubscribeMutationLoading,
  };
}
